import { useLayoutEffect, useState } from "react";

const QUERY = "(max-width: 991px)";

/**
 * True when viewport matches SCSS `@include non-desktop` (tablet + mobile).
 * Prefer this over UA-based `isMobileOrTablet()` when layout should follow breakpoints.
 */
export function useNonDesktopViewport(): boolean {
  const [matches, setMatches] = useState(() =>
    typeof window !== "undefined" ? window.matchMedia(QUERY).matches : false
  );

  useLayoutEffect(() => {
    const mq = window.matchMedia(QUERY);
    const onChange = () => setMatches(mq.matches);
    onChange();
    mq.addEventListener("change", onChange);
    return () => mq.removeEventListener("change", onChange);
  }, []);

  return matches;
}
